import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const EditInsertModal = ({ show, handleClose, onInsert }) => {
  const [file, setFile] = useState(null);
  const [url, setUrl] = useState("");

  const handleInsert = () => {
    if (file) {
      const localUrl = URL.createObjectURL(file);
      onInsert(localUrl);
    } else if (url) {
      onInsert(url);
    }
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Insert Image</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label>Select from files</Form.Label>
          <Form.Control
            type="file"
            onChange={(e) => setFile(e.target.files[0])}
          />
        </Form.Group>

        <Form.Group>
          <Form.Label>Image URL</Form.Label>
          <Form.Control
            value={url}
            onChange={(e) => setUrl(e.target.value)}
          />
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <Button className="btn-orange" onClick={handleInsert}>
          Insert Image
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditInsertModal;